import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from 'chart.js';
// import ChartDataLabels from 'chartjs-plugin-datalabels'; // opcional

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  // ChartDataLabels
);

const GraficaFrecuenciaMotivos = ({ data }) => {
//  console.log("📥 Desde el componente gráfica");
//  console.log("🔎 Motivos recibidos:", data);

  // 🧹 Validación defensiva y limpieza
  const motivos = Array.isArray(data)
    ? data.map(m => m?.trim()).filter(v => v)
    : [];

  if (motivos.length === 0) {
    //console.warn("⚠️ No se encontraron motivos válidos.");
  }

  // 📊 Agrupamos por motivo textual
  const frecuencia = {};
  motivos.forEach(motivo => {
    frecuencia[motivo] = (frecuencia[motivo] || 0) + 1;
  });
  //console.log("📊 Frecuencia agrupada:", frecuencia);
  const labels = Object.keys(frecuencia).sort(); // orden alfabético
  const valores = labels.map(k => frecuencia[k]);

  // 🎨 Colores institucionales
  const backgroundColor = labels.map(() => '#66b3ff');
  const borderColor = labels.map(() => '#3399ff');

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Frecuencia por Motivo',
        data: valores,
        backgroundColor,
        borderColor,
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: context => `Repeticiones: ${context.raw}`
        }
      },
      // datalabels: {
      //   anchor: 'end',
      //   align: 'top',
      //   color: '#000',
      //   font: {
      //     weight: 'bold',
      //     size: 12
      //   },
      //   formatter: value => value
      // }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Cantidad' }
      },
      x: {
        title: { display: true, text: '' },
        ticks: {
          callback: val => labels[val]?.length > 30
            ? labels[val].slice(0, 30) + '…'
            : labels[val]
        }
      }
    }
  };

  return (
    <div style={{ maxWidth: '900px', margin: '2rem auto' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '1rem' }}>
        Frecuencia por Motivo de Devolución
      </h4>
      {labels.length > 0 ? (
        <Bar data={chartData} options={options} />
      ) : (
        <p style={{ textAlign: 'center', color: '#999' }}>
          No hay datos válidos para mostrar.
        </p>
      )}
    </div>
  );
};

export default GraficaFrecuenciaMotivos;